import {useQuery} from "react-apollo";
import gql from "graphql-tag";

import {
    GetChatConversationFromLegacyIdQueryQuery,
    GetChatConversationFromLegacyIdQueryQueryVariables,
    GetChatConversationIdQueryQuery,
    GetChatConversationIdQueryQueryVariables,
} from "../../../../types/generated";

const GetChatConversationFromIdQuery = gql`
    query getChatConversationIdQuery($id: String!) {
        getChatConversation(id: $id) {
            id
            sourceId
        }
    }
`;

const GetChatConversationFromLegacyIdQuery = gql`
    query getChatConversationFromLegacyIdQuery($id: String!) {
        getChatConversationFromLegacyId(id: $id) {
            id
            sourceId
        }
    }
`;

export const useChatIdResolver = (urlId: string | undefined) => {
    const {
        data: chatData,
        loading: chatLoading,
        error: chatError,
    } = useQuery<GetChatConversationIdQueryQuery, GetChatConversationIdQueryQueryVariables>(
        GetChatConversationFromIdQuery,
        {
            variables: {id: urlId},
            skip: !urlId,
            fetchPolicy: "cache-first",
        },
    );

    const {
        data: legacyChatData,
        loading: legacyChatLoading,
        error: legacyChatError,
    } = useQuery<
        GetChatConversationFromLegacyIdQueryQuery,
        GetChatConversationFromLegacyIdQueryQueryVariables
    >(GetChatConversationFromLegacyIdQuery, {
        variables: {id: urlId},
        skip: !urlId || !!chatData?.getChatConversation?.id,
        fetchPolicy: "cache-first",
    });

    const resolvedConversationId =
        chatData?.getChatConversation?.id ||
        legacyChatData?.getChatConversationFromLegacyId?.id ||
        "";
    const resolvedChatGroupId =
        chatData?.getChatConversation?.sourceId ||
        legacyChatData?.getChatConversationFromLegacyId?.sourceId ||
        "";

    return {
        conversationId: resolvedConversationId,
        chatGroupId: resolvedChatGroupId,
        loading: chatLoading || legacyChatLoading,
        error:
            legacyChatError ||
            (chatError && !chatError.message.includes("Could not find conversation")
                ? chatError
                : !resolvedChatGroupId && !resolvedConversationId
                ? new Error("No matching conversation id could be found")
                : undefined),
    };
};
